export enum CampaignType {
  MAPPED_CAMPAIGN = 'mapped',
  UNMAPPED_CAMPAIGN = 'unmapped',
  UNDER_PROCESSING_CAMPAIGN = 'underProcessing'
}
